import { render, staticRenderFns } from "./EditPosts.vue?vue&type=template&id=3025bffe&scoped=true&"
import script from "./EditPosts.vue?vue&type=script&lang=ts&"
export * from "./EditPosts.vue?vue&type=script&lang=ts&"
import style0 from "./EditPosts.vue?vue&type=style&index=0&id=3025bffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3025bffe",
  null
  
)

export default component.exports